import {
    useState,
    useMemo,
    useEffect,
} from 'react';
import {
    Container,
    BoxSelect,
    BtnSearch,
    Content,
    Title
} from './styled';
import { ChartCompany } from './ChartCompany';
import { DatePicker, InputList } from '../../../../components';
import { IoIosSearch } from 'react-icons/io';
import moment from 'moment';
import { apiAdmin } from '../../../../service/api';
import { TfiTimer } from "react-icons/tfi";


export function ServiceTime() {

    const [dateStart, setDateStart] = useState(
        moment().subtract(6, 'months').format('YYYY-MM-DD')
    );
    const [dateEnd, setDateEnd] = useState(
        moment().format('YYYY-MM-DD')
    );
    const vision_type = [
        {
            id: 0,
            name: 'Total - Mensal',
            value: 'M',
        },
        {
            id: 1,
            name: 'Total - Semanal',
            value: 'W',
        }, {
            id: 2,
            name: 'Total - Diário',
            value: 'D',
        }
    ];
    const [visionTypeSelected, setVisionTypeSelected] = useState({
        id: 0,
        name: 'Total - Mensal',
        value: 'M',
    });
    const [dataCompanies, setDataCompanies] = useState([]);
    const [loading, setLoading] = useState(false);


    const searchDataCompanies = async (dateStart, dateEnd, type) => {
        try {
            setLoading(true);
            setDataCompanies([]);
            const { data } = await apiAdmin.post(`/tempo-atendimento?dt_ini=${dateStart}&dt_fim=${dateEnd}&tipo_visao=${type}`)
            setDataCompanies(data);
            setLoading(false);
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        searchDataCompanies(
            moment(dateStart).format('DD/MM/YYYY'),
            moment(dateEnd).format('DD/MM/YYYY'),
            visionTypeSelected.value
        )
    }, [])

    const myStateElements = useMemo(() => dataCompanies?.map((company) => {
        const { empresa } = company;
        const objKeys = {
            'M': 'mes_extenso',
            'W': 'semana',
            'D': 'dia'
        }
        return (
            <ChartCompany
                key={empresa}
                company={company}
                objKey={objKeys[visionTypeSelected.value]}
            />
        )
    }), [dataCompanies]);

    return (
        <Container>
            <BoxSelect>
                <div className='box--'>
                    <div className='line-'>
                        <DatePicker
                            className="date"
                            value={dateStart}
                            onChange={setDateStart}
                        />
                        <span> - </span>
                        <DatePicker
                            className="date"
                            value={dateEnd}
                            onChange={setDateEnd}
                        />
                    </div>
                    <div className='line-'>
                        <div className='list-'>
                            <InputList
                                options={vision_type}
                                value={visionTypeSelected?.name}
                                onChange={(e) => { setVisionTypeSelected(e) }}
                                toView={'name'}
                            />
                        </div>
                        <BtnSearch
                            disabled={loading ? 1 : 0}
                            onClick={() => {
                                searchDataCompanies(
                                    moment(dateStart).format('DD/MM/YYYY'),
                                    moment(dateEnd).format('DD/MM/YYYY'),
                                    visionTypeSelected.value
                                )
                            }}
                        >
                            {loading
                                ? <span className='loader' />
                                : <IoIosSearch />
                            }
                        </BtnSearch>
                    </div>
                </div>
            </BoxSelect>
            <Content>
                <Title>
                    <span>
                        <TfiTimer fontSize={'2rem'} />
                    </span>
                    <div>
                        {`Acumulado de horas realizadas em todos atendimentos`}
                    </div>
                </Title>
                {myStateElements}
            </Content>
        </Container >
    );
}
